/**
 * Tiny module-level store for passing a File object across route navigation.
 * Because this is a SPA, the module stays alive between routes.
 * The receiver calls takePendingAnalysisFile() which clears it after reading.
 */

let _pendingAnalysisFile = null;

export function setPendingAnalysisFile(file) {
  _pendingAnalysisFile = file;
}

export function takePendingAnalysisFile() {
  const file = _pendingAnalysisFile;
  _pendingAnalysisFile = null;
  return file;
}
